export enum PBVisualType {
  Report = 1,
  Dashboard = 2,
  Visual = 3,
  URL = 4,
}
